import React from 'react'
import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import SectionTitle from '../../../../components/kit/SectionTitle'
import InfoPaper from '../../../../components/InfoPaper'
import { CloseIcon } from '../../../../assets/icons'
import './SignerOptionsModal.scss'

const SignerOptionsModal = ({
  showSignerOptionsModal,
  toggleSignerOptionsModal,
  showMnemonicModal,
  showPemModal,
  showKeystoreModal,
  showPrivateKeyModal,
  chain,
}: {
  showSignerOptionsModal: boolean
  toggleSignerOptionsModal: () => void
  showMnemonicModal: () => void
  showPemModal: () => void
  showKeystoreModal: () => void
  showPrivateKeyModal: () => void
  chain: string
}) => {
  const handleSelectMnemonic = () => {
    toggleSignerOptionsModal()
    showMnemonicModal()
  }

  const handleSelectPem = () => {
    toggleSignerOptionsModal()
    showPemModal()
  }

  const handleSelectKeystore = () => {
    toggleSignerOptionsModal()
    showKeystoreModal()
  }

  const handleSelectPrivateKey = () => {
    toggleSignerOptionsModal()
    showPrivateKeyModal()
  }

  return (
    <Modal
      open={showSignerOptionsModal}
      onClose={toggleSignerOptionsModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: 'auto',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            gap: '2rem',
            borderRadius: '16px',
            boxSizing: 'border-box',
            padding: '24px',
          }}>
          <div className="topRow">
            <div className="modalTitle">
              <SectionTitle title="Connect your wallet to sign the transactions:" />
            </div>
            <span className="closeIcon" onClick={toggleSignerOptionsModal}>
              <CloseIcon />
            </span>
          </div>
          <InfoPaper infoText="ZoidPay will not store any information about your wallet. It will be used in your browser only, to sign the transactions you create." />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              gap: '1rem',
              flexWrap: 'wrap',
              width: '100%',
            }}>
            {chain === 'multiversx' ? (
              <>
                <Button
                  className="btn btn-primary"
                  color="secondary"
                  size="medium"
                  variant="outlined"
                  onClick={handleSelectKeystore}>
                  Connect with Keystore
                </Button>
                <Button
                  className="btn btn-primary"
                  color="secondary"
                  size="medium"
                  variant="outlined"
                  onClick={handleSelectPem}>
                  Connect with PEM
                </Button>
              </>
            ) : null}
            <Button
              className="btn btn-primary"
              color="secondary"
              size="medium"
              variant="outlined"
              onClick={handleSelectMnemonic}>
              Connect with seed phrase
            </Button>
            {chain !== 'multiversx' ? (
              <Button
                className="btn btn-primary"
                color="secondary"
                size="medium"
                variant="outlined"
                onClick={handleSelectPrivateKey}>
                Connect with private key
              </Button>
            ) : null}
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}

export default SignerOptionsModal
